import BaseCta from './BaseCta';

export { useBaseCta } from './useBaseCta';
export { type BaseCtaProps } from './BaseCta';

export default BaseCta;
